export default function (context, data) {
    context.state.selections = [];
    if(!data&&!data.length) return;
    data.forEach(i=>{
        context.state.selections.push(i);
    });
}